import { render, staticRenderFns } from "./imagechoice.vue?vue&type=template&id=1f555ac8"
import script from "./imagechoice.vue?vue&type=script&lang=js"
export * from "./imagechoice.vue?vue&type=script&lang=js"
import style0 from "./imagechoice.vue?vue&type=style&index=0&id=1f555ac8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports